import { useContext, useEffect, useState } from "react";
import "./App.css";
import Modal from "react-bootstrap/Modal";
import MainScreen from "./pages/MainScreen/MainScreen";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { DasboardContext } from "./context/dashboard-context";

function App() {
  const { userInfo } = useContext(DasboardContext);
  const [sessionControl, setSessionControl] = useState(true);

  useEffect(() => {
    const hasRefreshed = localStorage.getItem("hasRefreshed");

    if (hasRefreshed !== "true") {
      localStorage.setItem("hasRefreshed", "true");
      window.location.reload();
    }
  }, []);

  return (
    <>
      {(!userInfo || Object.keys(userInfo).length === 0) && (
        <Modal show={sessionControl}>
          <Modal.Header>Lütfen Giriş Yapınız</Modal.Header>
          <Modal.Body className="device-add-wrapper">
            <p>Oturum süresi doldu, lütfen giriş yapınız!</p>
            <div className="button-wrapper">
              <a href="/login" onClick={() => setSessionControl(false)}>
                Giriş Yap
              </a>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <MainScreen />
      <ScrollToTop />
    </>
  );
}

export default App;
